interface MessageType {
  title: string;
  message: string;
}

export const ALERT_MESSAGE: { [key: string]: MessageType } = {
  INVALID_FILE_TYPE: {
    title: 'ประเภทไฟล์ไม่ถูกต้อง',
    message: 'กรุณาอัปโหลดไฟล์ JPG หรือ PNG',
  },
  INVALID_FILE_SIZE: {
    title: 'ขนาดไฟล์เกินกำหนด',
    message: 'กรุณาอัปโหลดไฟล์ไม่เกิน 10 MB',
  },
  CAMERA_PERMISSION_DENIED: {
    title: 'การอนุญาตถูกปฏิเสธ',
    message: 'กรุณาอนุญาตให้การใช้งานกล้อง',
  },
  FORM_SUBMIT_ERROR: {
    title: 'เกิดข้อผิดพลาด',
    message: 'กรุณาลองใหม่อีกครั้ง',
  },
  COPY_SUCCESS: {
    title: 'คัดลอกเรียบร้อย',
    message: 'คัดลอกที่อยู่ของเว็บไซต์เรียบร้อย<span>แล้ว</span>',
  },
} as const;
